import { useState } from 'react';

import { I18n } from 'common/i18n';
import VizMessageError from 'common/components/VizMessageError';

import Constants from 'lib/Constants';
import StorytellerUtils from 'lib/StorytellerUtils';
import { type VisualizationCanvasBlockComponent } from 'types';

import { type ReactRendererProps } from '../../shared/ComponentRegistry';
import { VizCanvas } from './viz-canvas';

export const resizableProps = () => {
  return {
    resizeSupported: true,
    resizeOptions: {
      minHeight: Constants.MINIMUM_COMPONENT_HEIGHTS_PX.VISUALIZATION,
    },
  };
};

/**
 * React renderer for the visualization canvas embed. The referenced asset can be deleted or
 * made private after the component is added to a story, so an unresolvable vif renders an
 * error in place of the visualization rather than leaving the component blank.
 */
export const ComponentVizCanvas = ({ componentData }: ReactRendererProps) => {
  const [hasError, setHasError] = useState(false);
  const { type, value } = componentData as VisualizationCanvasBlockComponent;
  const typeClasses = StorytellerUtils.typeToClassesForComponentType(type);
  const visualizationConfig = value?.dataset;

  if (!visualizationConfig?.datasetUid || !visualizationConfig?.vifId) {
    return null;
  }

  const errorHeight = value?.layout?.height ?? Constants.MINIMUM_COMPONENT_HEIGHTS_PX.VISUALIZATION;

  return (
    <div className={`component ${typeClasses}`} data-testid="component-viz-canvas">
      <div className="component-content story-viz-react">
        <VizCanvas visualizationConfig={visualizationConfig} onError={setHasError} />
        {hasError && (
          <div className="viz-canvas-error-container" style={{ height: `${errorHeight}px` }}>
            <VizMessageError
              type="privateOrDeletedAsset"
              errorMessage={I18n.t('editor.viz_canvas.errors.status')}
            />
          </div>
        )}
      </div>
    </div>
  );
};
